var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPencil01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.37206 10.7659C3.47025 10.5107 3.51934 10.383 3.60354 10.3245C3.67713 10.2735 3.76818 10.2541 3.85618 10.2709C3.95687 10.2902 4.05357 10.3869 4.24697 10.5803L5.75303 12.0863C5.94643 12.2797 6.04313 12.3764 6.06236 12.4771C6.07916 12.5651 6.05984 12.6562 6.00875 12.7297C5.95028 12.814 5.82264 12.863 5.56736 12.9612L2 14.3333L3.37206 10.7659Z",
    stroke: "#3B5A6F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42289 10.6339C3.5139 10.3972 3.5594 10.2789 3.61882 10.1682C3.6716 10.0699 3.73252 9.97617 3.80093 9.88801C3.87795 9.78876 3.96758 9.69912 4.14685 9.51985L11.6667 2.00004C12.4031 1.26366 13.597 1.26366 14.3334 2.00004C15.0697 2.73642 15.0697 3.93033 14.3333 4.66671L6.81352 12.1865C6.63425 12.3658 6.54461 12.4554 6.44536 12.5324C6.3572 12.6009 6.26347 12.6618 6.16515 12.7146C6.05445 12.774 5.93614 12.8195 5.69951 12.9105L2 14.3334L3.42289 10.6339Z",
    stroke: "#6162C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil01);
export default __webpack_public_path__ + "static/media/IconPencil_01.fe2db89c922ce26134968cb53a7cb46d.svg";
export { ForwardRef as ReactComponent };